import { createAsyncThunk } from '@reduxjs/toolkit';
import { deactivateInvoiceScanningAddress } from '../services/deactivateInvoiceScanningAddress';

export const deactivateInvoiceScanningAddressThunk = createAsyncThunk(
  'invoices/deactivateInvoiceScanningAddress',
  async (params, { getState, dispatch }) => {
    const businessId = params.businessId;
    const email = params.email;
    if (!businessId) {
      throw new Error('Business ID is required');
    }
    if (!email) {
      throw new Error('Email is required');
    }

    const response = await deactivateInvoiceScanningAddress(businessId, email);

    return response;
  }
);
